import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Observer, of } from 'rxjs';
import { SetLanguageService } from '../_services/setLanguage.service';

@Injectable()
export class TranslationLoaderResolver {
  constructor(
    private translate: TranslateService,
    private languageService: SetLanguageService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let lang = this.languageService.getSessionCurrentLanguage();
    let reloadTranslation: boolean = false;

    if (lang === null || lang === undefined || lang === 'null') {
      this.languageService.inizializeLanguage();
      lang = this.languageService.getSessionCurrentLanguage();

      reloadTranslation = true;
    }

    if (this.translate.instant('last.dummy') === 'last.dummy') {
      reloadTranslation = true;
    }

    if (reloadTranslation == true) {
      return new Observable((observer: Observer<any>) => {
        this.translate.getTranslation(lang).subscribe({
          next: (elem) => {
            //console.log(elem)
          },
          complete: () => {
            observer.next(true);
            observer.complete();
          },
          error: (e) => {
            console.error(e);
            observer.next(true);
            observer.complete();
          },
        });
      });
    }

    return of(true);
  }
}
